import {
  css
} from 'lit';

export const IconStyle = css`
.icon {
  display: block;
  width: 100%;
  height: 100%;
  margin: var(--lds-spacing-icon-margin-top) var(--lds-spacing-icon-margin-right) var(--lds-spacing-icon-margin-bottom) var(--lds-spacing-icon-margin-left);
}

.icon.inline {
  display: inline-block;
  width: var(--lds-spacing-icon-inline-width);
  height: var(--lds-spacing-icon-inline-height);
  vertical-align: middle;
  margin-top: var(--lds-spacing-icon-inline-margin-top);
  fill: currentColor;
}

.icon.inline.icon-radio circle:first-child,
.icon.inline.icon-checkbox rect {
  stroke: currentColor;
}

.icon.icon-radio circle:first-child,
.icon.icon-checkbox rect {
  fill: none;
  stroke: var(--lds-color-grey-900);
  stroke-width: 1.75;
}

.icon.inline.button-icon {
  height: var(--lds-spacing-button-subcomponent-icon-height);
  width: var(--lds-spacing-button-subcomponent-icon-width);
  margin-top: var(--lds-spacing-button-subcomponent-icon-margin-top);
}

.icon.inline.button-icon.after {
  margin-left: var(--lds-spacing-button-subcomponent-icon-margin-between);
}

.icon.inline.button-icon.before {
  margin-right: var(--lds-spacing-button-subcomponent-icon-margin-between);
}
`;

export default IconStyle;
